import React from "react"
//import { Link } from "gatsby"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Home" description="" />
    <Hero />
    <div class="bg-gray-700">
      <div class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8 lg:py-20">
        <div class="max-w-4xl mx-auto text-center">
          <h2 class="text-3xl leading-9 font-extrabold text-white sm:text-4xl sm:leading-10">
            We promise infectious passion to elevate performance.{" "}
          </h2>
          <p class="mt-3 text-xl leading-7 text-indigo-200 sm:mt-4">
            Providing Canadians with quality freestyle skiing programs and
            services that build people, train athletes and deliver champions.
          </p>
        </div>
        <dl class="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8">
          <div class="flex flex-col">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Members
            </dt>
            <dd class="order-1 text-5xl leading-none font-extrabold text-white">
              4000
            </dd>
          </div>
          <div class="flex flex-col mt-10 sm:mt-0">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Clubs
            </dt>
            <dd class="order-1 text-5xl leading-none font-extrabold text-white">
              73
            </dd>
          </div>
          <div class="flex flex-col mt-10 sm:mt-0">
            <dt class="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Provinces
            </dt>
            <dd class="order-1 text-5xl leading-none font-extrabold text-white">
              10
            </dd>
          </div>
        </dl>
      </div>
    </div>
    {/* {data.wpgraphql.posts.edges.map(({ node }) => (
      <div key={node.slug}>
        <Link to={`/${node.slug}`}>
          <div
            dangerouslySetInnerHTML={{
              __html: node.title
            }}
          />{" "}
        </Link>{" "}
        <div
          dangerouslySetInnerHTML={{
            __html: node.excerpt
          }}
        />{" "}
      </div>
    ))} */}
    {/* <h2> Pages </h2>{" "}
    {data.wpgraphql.pages.edges.map(({ node }) => (
      <div key={node.slug}>
        <Link to={`/${node.slug}`}>
          <div
            dangerouslySetInnerHTML={{
              __html: node.title
            }}
          />{" "}
        </Link>{" "}
        <div
          dangerouslySetInnerHTML={{
            __html: node.excerpt
          }}
        />{" "}
      </div>
    ))}{" "}
    <br />
    <hr />
    <br />
    <h2> Categories </h2>{" "}
    {data.wpgraphql.categories.edges.map(({ node }) => (
      <div key={node.slug}>
        <Link to={`/category/${node.slug}`}>
          <div
            dangerouslySetInnerHTML={{
              __html: node.name
            }}
          />{" "}
        </Link>{" "}
      </div>
    ))}{" "}
    <br />
    <hr />
    <br /> */}
  </Layout>
)

export default IndexPage

export const pageQuery = graphql`
  query GET_POSTS {
    wpgraphql {
      posts(first: 1000, after: null) {
        edges {
          node {
            databaseId
            slug
            title
            date
            content(format: RENDERED)
            featuredImage {
              altText
              link
              mediaItemUrl
              uri
            }
          }
        }
      }
      pages(first: 1000, after: null) {
        edges {
          node {
            databaseId
            slug
            title
            date
            content(format: RENDERED)
            featuredImage {
              altText
              link
              mediaItemUrl
              uri
            }
          }
        }
      }
      categories(first: 1000) {
        edges {
          node {
            databaseId
            name
            slug
          }
        }
      }
    }
  }
`
